import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { CustomSelect, SelectOption } from "@components/select";
import { Config } from "@components/table";
import { useForm } from "react-hook-form";
import styles from "./banks.module.scss";
import { useBoolState } from "@hooks/use-bool-state";
import { RegexModal } from "./regexModal";
import {
  AdminBank,
  BankRegex,
  CreateAdminBankRequest,
  RegexForm,
} from "@features/admin/banks/api";
import { store } from "@app/store";
import {
  removeRegex,
  selectRegex,
  setSelectedBank,
} from "@features/admin/banks/slice";
import { useAdminBanks } from "@features/admin/banks";
import { yupResolver } from "@hookform/resolvers/yup";
import { bankSchema } from "./schemas";
// import MultiSelect from "@components/multiSelect";
import { useEffect } from "react";
import { useNotification } from "@hooks/use-notification";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
};

const defaultData: AdminBank = {
  alias: "",
  bank_id_code: "",
  id: "",
  logo: "",
  name: "",
  phone_number: "",
  push_notification_packages: "",
  uniq_only: false,
  regexes: [],
  region: { id: 0 },
  require_account_for_sbp: true,
  country: "",
  currency: "",
  method: "",
  type: "",
};

// const notifyOptions = [
//   { text: "SMS", value: "sms" },
//   { text: "PUSH", value: "push" },
// ];

// const methodOptions = [
//   { text: "sbp", value: "sbp" },
//   { text: "account_transfer", value: "account_transfer" },
//   { text: "card_transfer", value: "card_transfer" },
// ];

type tempFormType = CreateAdminBankRequest & {
  notif_str?: string;
};

export const AdminBankModal = ({ hideModal, isModalOpen }: Props) => {
  const { state, createAdminBank, updateAdminBank, getAdminBanks } = useAdminBanks();
  const tableConfig: Config<AdminBank> = [
    {
      label: "Alias",
      source: "alias",
      renderComponent: () => <Input name="alias" control={control} />,
    },
    {
      label: "Имя",
      source: "name",
      renderComponent: () => <Input name="name" control={control} />,
    },
    {
      label: "Лого",
      source: "logo",
      renderComponent: () => <Input name="logo" control={control} />,
    },
    {
      label: "Уведомления",
      source: "push_notification_packages",
      renderComponent: () => (
        // <MultiSelect
        //   name="push_notification_packages"
        //   control={control}
        //   options={notifyOptions}
        // ></MultiSelect>
        <Input name="notif_str" control={control} />
      ),
    },
    {
      label: "Uniq_only",
      source: "uniq_only",
      renderComponent: () => (
        <CustomSelect control={control} options={options} name={"uniq_only"} />
      ),
    },
    {
      label: "Номер Телефона",
      source: "phone_number",
      renderComponent: () => <Input name="phone_number" control={control} />,
    },
    // {
    //   label: "Регион",
    //   source: "region",
    //   visible: state.selectedBank != null,
    //   renderComponent: () => (
    //     <Input name="region.id" control={control} type="number" />
    //   ),
    // },
    {
      label: "ID",
      source: "bank_id_code",
      renderComponent: () => <Input name="bank_id_code" control={control} />,
    },
    {
      label: "Страна",
      source: "country",
      renderComponent: () => <Input name="country" control={control} />,
    },
    {
      label: "Валюта",
      source: "currency",
      renderComponent: () => <Input name="currency" control={control} />,
    },
    {
      label: "Regex",
      source: "regexes",
      renderComponent: () => (
        <div>
          {state.regexes.map((regex) => (
            <div
              key={regex.id}
              style={{ marginBottom: "3px", borderBottom: "1px solid black" }}
            >
              <div style={{ marginBottom: "3px" }}>{regex.description ?? regex.regex}</div>
              <span
                onClick={() => handleRegexModal(regex)}
                style={{ color: "orange", cursor: "pointer" }}
              >
                Изменить
              </span>
              &nbsp;
              <span style={{ color: "red", cursor: "pointer" }} onClick={() => regex.id && store.dispatch(removeRegex(regex.id))}>Удалить</span>
            </div>
          ))}
          <div
            style={{ marginTop: "3px", color: "green", cursor: "pointer" }}
            onClick={() => handleRegexModal()}
          >
            Добавить
          </div>
        </div>
      ),
    },
    // {
    //   label: "Метод",
    //   source: "method",
    //   visible: state.selectedBank != null,
    //   renderComponent: () => (
    //     <CustomSelect name="method" control={control} options={methodOptions} />
    //   ),
    // },
    // {
    //   label: "Тип",
    //   source: "type",
    //   visible: state.selectedBank != null,
    //   renderComponent: () => <Input name="type" control={control} />,
    // },
    {
      label: "Необходим аккаунт для СБП",
      source: "require_account_for_sbp",
      renderComponent: () => (
        <CustomSelect
          control={control}
          options={options}
          name={"require_account_for_sbp"}
        />
      ),
    },
  ];
  const notification = useNotification();
  const [isRegexModalOpen, showRegexModal, hideRegexModal] =
    useBoolState(false);

  const options: SelectOption[] = [
    { text: "yes", value: "true" },
    { text: "no", value: "false" },
  ];

  const { control, handleSubmit, setValue, reset } = useForm<tempFormType>({
    defaultValues: {
      alias: "",
      bank_id_code: "",
      name: "",
      region: {},
    },
    resolver: yupResolver(bankSchema),
  });

  const handleRegexModal = (regex?: BankRegex | RegexForm) => {
    store.dispatch(selectRegex(regex));
    showRegexModal();
  };
  useEffect(() => {
    if (state.selectedBank != null) {
      setValue("alias", state.selectedBank.alias);
      setValue("bank_id_code", state.selectedBank.bank_id_code);
      setValue("name", state.selectedBank.name);
      setValue("region", state.selectedBank.region);
      setValue("logo", state.selectedBank.logo);
      setValue("phone_number", state.selectedBank.phone_number);
      setValue("notif_str", state.selectedBank.push_notification_packages);
      setValue(
        "require_account_for_sbp",
        String(state.selectedBank.require_account_for_sbp) as unknown as boolean
      );
      setValue(
        "uniq_only",
        String(state.selectedBank.uniq_only) as unknown as boolean
      );
      setValue("regexes", state.regexes);
      setValue("country", state.selectedBank.country);
      setValue("currency", state.selectedBank.currency);
      setValue("type", state.selectedBank.type);
      setValue("method", state.selectedBank.method);
    } else {
      reset();
    }
  }, [state.selectedBank]);
  const onsubmit = (data: tempFormType) => {
    data.regexes = state.regexes;

    let promise;
    if (data.notif_str != null && data.notif_str != "") {
      try {
        const parsed = JSON.parse(data.notif_str);
        if (
          !Array.isArray(parsed) ||
          parsed.some((val) => typeof val !== "string")
        )
          throw "not array";
        data.push_notification_packages = parsed;
      } catch {
        notification.addNotification('Ошибка в заполнении поля "Уведомления"');
        return;
      }
    } else {
      data.push_notification_packages = [];
    }
    if (state.selectedBank == null) {
      if (data.method == null) data.method = "";
      if (data.type == null) data.type = "";
      data.region = null;
      promise = createAdminBank(data);
    } else {
      promise = updateAdminBank(state.selectedBank.id, data);
    }
    promise.then(() => {
      store.dispatch(setSelectedBank(null));
      getAdminBanks()
    });
    closeModal();
  };
  const closeRegexModal = () => {
    hideRegexModal();
    setValue("regexes", state.regexes);
  };

  const closeModal = () => {
    store.dispatch(setSelectedBank(null));
    hideModal();
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={
          state.selectedBank != null ? "Редактировать банк" : "Создание банка"
        }
        className={styles.modal}
      >
        <form>
          <RowTable config={tableConfig} data={defaultData}></RowTable>
          <Button onClick={handleSubmit(onsubmit)}>Сохранить</Button>
        </form>
        <RegexModal
          isModalOpen={isRegexModalOpen}
          hideModal={closeRegexModal}
        />
      </Modal>
    </>
  );
};
